import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import {
  Box,
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Tooltip,
} from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import InfoIcon from '@material-ui/icons/Info';
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa6";
import SortIcon from '@material-ui/icons/Sort';
import PropTypes from 'prop-types';
import { storeContext } from '../provider/Provider';
import useStyles from './SearchIntelligence.style';
import {
  StyledTableHeadCell,
  StyledTableHeadCell1,
} from '../../customUI/table/TableStyles';
import theme from '../../theme';
import SearchIntelligenceRow from './SearchIntelligenceRow';
import PrimaryContainer from '../../customUI/PrimaryContainer';
import MobileTitle from '../../customUI/MobileTitle';
import MobileSearchIntelligence from './MobileSearchIntelligence';
import logo from '../../images/logo-2.svg';
import AirtableRow from './AirtableRow';
import MobileAirtable from './MobileAirtable';

const { REACT_APP_SEARCH_INTELLIGENCE_API_KEY, REACT_APP_AIRTABLE_API_BASE_URL, REACT_APP_AIRTABLE_API_TOKEN, REACT_APP_AIRTABLE_BASE_ID, REACT_APP_AIRTABLE_TABLE_ID } = process.env;

const SearchIntelligence = () => {
  const classes = useStyles();
  const { state } = useContext(storeContext);
  let isPhone = false;
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });

  const [campaigns, setCampaigns] = useState([]);
  const [airTableCampaigns, setAirtableCampaigns] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [orderBy, setOrderBy] = useState('');
  const [orderType, setOrderType] = useState('');

  useEffect(() => {
    if(airTableCampaigns.length > 0){
      const sortedAirtableCampaigns = [...airTableCampaigns].sort((a, b) => {
        const aTittle = a.find(campaign => campaign.Tittle)?.[orderBy] || '';
        const bTittle = b.find(campaign => campaign.Tittle)?.[orderBy] || '';
        if (!aTittle) return 1;
        if (!bTittle) return -1;
          if (orderType === 'asc') {
            return aTittle.localeCompare(bTittle);
          }
          return bTittle.localeCompare(aTittle);
        })

      setAirtableCampaigns(sortedAirtableCampaigns)
    }
  }, [orderBy, orderType])

  const processAirtableData = (response) => Object.values(response.data.records
      .map((record) => ({ ...record.fields}))
      .reduce((acc, order) => {
        const orderId = order["Order ID"];
        if (!acc[orderId]) {
          acc[orderId] = [];
        }
        acc[orderId].push(order);
        
        return acc;
      }, {}))

  const fetchAirtableData = async () => {
    axios
      .get(
          `${REACT_APP_AIRTABLE_API_BASE_URL}/${REACT_APP_AIRTABLE_BASE_ID}/${REACT_APP_AIRTABLE_TABLE_ID}?filterByFormula=FIND("${state.websiteSwitch.currentWebsite}"%2C+%7BClient%20site%7D)&sort[0][field]=Order ID&sort[0][direction]=asc`,
          {
              headers:{'Authorization': REACT_APP_AIRTABLE_API_TOKEN},
          }
      )
      .then((response) => {
          const parsedAirtableData = processAirtableData(response)
          setAirtableCampaigns(parsedAirtableData)
          setIsFetching(false);
      })
      .catch(() => {
          setIsFetching(false);
      });
  }

  const fetchSearchIntelligenceData = async () => {
    const sortingExpression = (orderBy === '' || orderType === '')? '': `&sort_by=${orderBy}&sort_order=${orderType}`;
    setIsFetching(true);
    axios
    .get(
        `https://admin.search-intelligence.co.uk/wp-json/si-rest-api/v1/client/campaigns?domain=${state.websiteSwitch.currentWebsite}&all_placements=0${sortingExpression}`,
        {
            headers:{'x-api-key': REACT_APP_SEARCH_INTELLIGENCE_API_KEY,},
        }
    )
    .then((res) => {
        setCampaigns(res.data)
        if(res.data.length === 0){
          fetchAirtableData();
        } else {
          setIsFetching(false);
        }
    })
    .catch(() => {
        fetchAirtableData()
    });
  }

  useEffect(() => {
    fetchSearchIntelligenceData()
  }, []);

  useEffect(() => {
    if(orderBy !== '' && campaigns.length > 0){
      fetchSearchIntelligenceData()
    }
  }, [orderBy, orderType]);

  const handleSortClick = (value) => {
    if (orderBy !== value){
      setOrderBy(value);
      setOrderType('asc');
    } else if(orderType === 'asc') {
      setOrderType(`desc`)
    } else {
      setOrderType('asc');
    }
  }; 
  

  if (isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }

  const CustomSortIcon = ({field}) => {
    if (orderBy === field) {
      if (orderType === 'asc') {
        return <FaSortUp color="grey" />;
      }
      return <FaSortDown color="grey" />;
    }
    return <FaSort color="grey" />;
  };

  CustomSortIcon.propTypes = {
    field: PropTypes.string.isRequired,
  };

  if (isPhone) {
    return (
      <>
        <MobileTitle title="Digital PR" />
        {campaigns.length > 0 && (
          <div>
            {campaigns.map((row) => (
              <MobileSearchIntelligence row={row} />
            ))}
          </div>
        )}
        {campaigns.length === 0 && airTableCampaigns.length > 0 && (
          <div>
            {airTableCampaigns.map((row) => (
              <MobileAirtable orderRow={row} />
            ))}
          </div>
        )}
        {campaigns.length === 0 && airTableCampaigns.length === 0 && (
          <>
            <PrimaryContainer>
              <div style={{ maxWidth: 1000, margin: 'auto' }}>
                <div className={classes.center}>
                    <img src={logo} className={classes.topLogo} alt="Hennessey Logo" height="75" />
                </div>
                <p className={classes.headingTitle}>Wanted to take your Site SEO Optimization into next level?</p>
                <p className={classes.paragraph}>
                    Building trusted link network pointing to your Site your organic traffic &apos;ll be growing naturally and lot of potential new clients &apos;ll be landing to your site!
                </p>
                <p className={classes.paragraph}>
                    Give us the chance to show how to show you how well thinking link campaign can take your SEO Optimization into next level and see how your convertions growth.
                </p>
                <div className={classes.center}>
                    <p className={classes.bigText}>We always make it easy for you.</p>
                </div>
              </div>
            </PrimaryContainer>
          </>
        )}
      </>
    );
  }
  if(campaigns.length){
    return (
      <div className={classes.wrapper}>
          <div className={classes.card}>
            <div className={classes.card__wrapper}>
              <div style={{ 
                  display: 'block',
                  padding: '20px 10px 50px 10px',
              }}>
                <div>
                  <div className={classes.card__header}>
                      <div style={{ width: '100%', justifyContent: 'flex-start', }}>
                          <div className={classes.heading}>Digital PR</div>
                      </div>
                  </div>
                  <div className={classes.searchTable}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} >
                                    <Box display='flex' flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('year')}>
                                      Year
                                      <CustomSortIcon field='year' />
                                    </Box>
                                </StyledTableHeadCell>
                                <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} >
                                    <Box display='flex' flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('month')}>
                                      Month
                                      <CustomSortIcon field='month' />
                                    </Box>
                                </StyledTableHeadCell>
                                <StyledTableHeadCell1 style={{ position: 'relative', cursor: 'pointer' }}>
                                    <Box display='flex' flex={1} justifyContent='space-between' onClick={() => handleSortClick('campaign_name')}>
                                        Campaign Name
                                        <CustomSortIcon field='campaign_name' />
                                    </Box>
                                </StyledTableHeadCell1>
                                <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }}>
                                    <Box display='flex' flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('first_link_date')}>
                                      Date
                                      <CustomSortIcon field='first_link_date' />
                                    </Box>
                                </StyledTableHeadCell>
                                <StyledTableHeadCell style={{ position: 'relative' }} >
                                    <Box display='flex' flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('ht_count_links')}>
                                      DR &ge; 70
                                      <CustomSortIcon field='ht_count_links' />
                                    </Box>
                                </StyledTableHeadCell>
                                <StyledTableHeadCell style={{ position: 'relative' }} >
                                    <Box display='flex' flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('count_links')}>
                                      Link Count
                                      <CustomSortIcon field='count_links' />
                                    </Box>
                                </StyledTableHeadCell>
                                <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }}>
                                    <Box display='flex' flex={1} justifyContent='left' alignItems='center' onClick={() => handleSortClick('status')}>
                                        Status
                                        <Box ml='5px' mt='5px'>
                                          <Tooltip style={{ width: '18px', height: '18px'}} title={<span style={{fontSize: '14px'}}>Campaign Article Status</span>} placement='top' arrow>
                                            <InfoIcon style={{color: theme.palette.primary.main, cursor: 'pointer'}} onClick={()=>{}} />
                                          </Tooltip>
                                        </Box>
                                        <CustomSortIcon field='status' />
                                    </Box>
                                </StyledTableHeadCell>
                                <StyledTableHeadCell style={{ position: 'relative' }} >
                                    <Box display='flex' flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleSortClick('video')}>
                                      Media
                                      {((orderType === 'asc' && orderBy === 'video') || (orderType === 'desc' && orderBy === 'video'))  && <Box ml={2} height={25} style={{ transform: orderType === 'asc' ? 'rotate(180deg)' : 'none' }}><SortIcon /></Box>}
                                    </Box>
                                </StyledTableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {campaigns.map((row) => (
                                <SearchIntelligenceRow row={row} />
                            ))}
                        </TableBody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
    </div>)
  }

  if(airTableCampaigns.length){
    return (
      <div className={classes.wrapper}>
        <div className={classes.card}>
          <div className={classes.card__wrapper}>
            <div style={{ 
                display: 'block',
                padding: '20px 10px 50px 10px',
            }}>
              <div>
                <div className={classes.card__header}>
                    <div style={{ width: '100%', justifyContent: 'flex-start', }}>
                        <div className={classes.heading}>Digital PR</div>
                    </div>
                </div>
                <div className={classes.searchTable}>
                  <Table>
                      <TableHead>
                          <TableRow>
                              <StyledTableHeadCell style={{ position: 'relative' }} onClick={() => handleSortClick('Task Started')} >
                                  <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                    Year
                                    <CustomSortIcon field='Task Started' />
                                  </Box>
                              </StyledTableHeadCell>
                              <StyledTableHeadCell style={{ position: 'relative' }} onClick={() => handleSortClick('Task Started')} >
                                  <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                    Month
                                    <CustomSortIcon field='Task Started' />
                                  </Box>
                              </StyledTableHeadCell>
                              <StyledTableHeadCell1 style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleSortClick('Tittle')} >
                                  <Box display='flex' flex={1} justifyContent='space-between'>
                                    Campaign Name
                                    <CustomSortIcon field='Tittle' />
                                  </Box>
                              </StyledTableHeadCell1>
                              <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleSortClick('Task Started')} >
                                  <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                    Date
                                    <CustomSortIcon field='Task Started' />
                                  </Box>
                              </StyledTableHeadCell>
                              <StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleSortClick('Status')} >
                                <Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
                                  <Box display='flex' flex={1} justifyContent='left' alignItems='center'>
                                      Status
                                      <Box ml='5px' mt='5px'>
                                        <Tooltip style={{ width: '18px', height: '18px'}} title={<span style={{fontSize: '14px'}}>Campaign Article Status</span>} placement='top' arrow>
                                          <InfoIcon style={{color: theme.palette.primary.main, cursor: 'pointer'}} onClick={()=>{}} />
                                        </Tooltip>
                                      </Box>
                                  </Box>
                                  <CustomSortIcon field='Status' />
                                </Box>
                              </StyledTableHeadCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {airTableCampaigns.map((row) => (
                              <AirtableRow orderRow={row} />
                          ))}
                      </TableBody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
   
  return (
    <div className={classes.wrapper}>
        <>
          <PrimaryContainer>
            <div style={{ maxWidth: 1000, margin: 'auto' }}>
              <div className={classes.center}>
                  <img src={logo} className={classes.topLogo} alt="Hennessey Logo" height="75" />
              </div>
              <p className={classes.headingTitle}>Enhance your SEO with links search engines will love</p>
              <p className={classes.paragraph}>
                Building a trusted link network that points back to your site increases your site&apos;s value to Google and gives potential customers new ways to discover you. As a result, your organic traffic will grow naturally, bringing potential new business to your site. 
              </p>
              <p className={classes.paragraph}>
                Our Digital PR solution focuses on strategic link building campaigns that optimize your SEO through placement of human interest and other timely, strategic stories that reference your company.
              </p>
              <div className={classes.center}>
                  <p className={classes.bigText} onClick={() => {
                    window.open(
                      'https://hennessey.zendesk.com/hc/en-us/requests',
                      '_blank'
                    );
                  }}
                  role="presentation"
                  style={{ cursor: 'pointer' }}>Hungry to know more? Contact your Account Manager to discuss or get started.</p>
              </div>
            </div>
          </PrimaryContainer>
        </>    
    </div>
  );
};

export default SearchIntelligence;
